<template>
  <div class="details animate-route">
    <a-row :gutter="24" type="flex">
      <a-col class="company-img" flex="724px">
        <img :src="imgUrl + customerInfo.companyImg" style="max-width: 700px" />
      </a-col>
      <a-col class="info" flex="auto">
        <img :src="imgUrl + customerInfo.customerImg" width="265" />
        <div class="title">{{ customerInfo.companyName }}</div>
        <div class="text">品牌名：{{ customerInfo.name }}</div>
        <div class="text">电话：{{ customerInfo.phone }}</div>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import { getCustomerById } from '@/api'
export default {
  data() {
    return {
      imgUrl: process.env.VUE_APP_IMG_URL,
      customerInfo: {},
    }
  },
  created() {
    const id = this.$route.query.id
    getCustomerById({ id: id }).then((res) => {
      this.customerInfo = res.result
    })
  },
}
</script>
<style lang="stylus">
@import './index'
route()
.details
  width 1300px
  margin 110px auto
  .info
    text-align left
    .title
      font-size 36px
      margin 35px 0 20px 0
    .text
      font-size 24px
      color #8c8c8c
    img
      border 1px #ddd solid
</style>
